import { FC, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, CircularProgress, styled, useMediaQuery, useTheme } from '@mui/material';

import Header from 'components/Header';
import Footer from 'components/Footer';
import { useAppSelector } from 'state/hooks';

const MainLayoutBox = styled(Box)(() => ({
  minWidth: '320px',
  justifyContent: 'center',
  alignItems: 'center',
  // background: 'linear-gradient(340deg, #97999B 0%, #122638 45.35%)',
  // backgroundImage: 'radial-gradient(farthest-side at 120% 70%, #848587, #3C5972, #1A3751, #1A3751, #122638)'
  backgroundImage: 'radial-gradient(farthest-side at 120% 70%, #9d9ea1, #4a6d8c, #22496b, #22496b, #1a3752)'
}));

const OutLetContainer = styled(Box)(({ theme }) => ({
  borderColor: theme.palette.grey.A100,
}));

const MainLayout: FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
  return (
    <MainLayoutBox sx={{ marginLeft: isMobile ? "0px" : '0px'  }}>
      <Header />
      <Box sx={{minHeight: 'calc(100vh - 100px)'}}>
        <Suspense
          fallback={
            <Box
              sx={{
                minHeight: 'calc(100vh - 100px)',
                fontSize: '100px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <CircularProgress size={40} sx={{ color: 'white' }} />
            </Box>
          }
        >
          <OutLetContainer>
            <Box justifyContent='center' sx={{ display: 'flex' }}>
              <Outlet />
            </Box>
          </OutLetContainer>
        </Suspense>
        </Box>
      <Footer />
    </MainLayoutBox>
  );
};

export default MainLayout;
